import React, { FC } from "react";
import {
  Button,
  Card,
  CardActionArea,
  CardActions,
} from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { Skeleton } from "@material-ui/lab";

interface Props {
  name: string;
  id: string;
  loading: boolean;
  alt?: string;
  extensions?: string;
  title?: string;
  height?: string;
  width?: string;
  url?: string;
  onChangeValue: (files: FileList) => void;
}

type InputProps = JSX.IntrinsicElements["input"] & Props;

const DEFAULT_EXTENSIONS = "image/*,.pdf,.doc,.docx"


const InputFile: FC<InputProps> = ({
  id = "input-file",
  name = "",
  loading = false,
  alt = "",
  title = "",
  width = "100%",
  onChangeValue,
  extensions = "",
  url,
}) => {
  const [dataFiles, setDataFiles] = React.useState<FileList>();
  const [onLoad, setOnLoad] = React.useState<boolean>(loading);

  const onChangeFile = (files: FileList): void => {
    onChangeValue(files);
  };

  const download = (): void => {
    if (url) {
      const a = document.createElement("a");
      a.href = `//${url}`;
      a.setAttribute("download", name);
      a.click();
    }
  };

  return (
    <>
      <Card elevation={0} style={{ backgroundColor: "#F9F9F9" }}>
        <CardActionArea>
          <div
            title={title}
            style={{
              minHeight: "241px",
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              // display: "flex",
              display:
                (dataFiles && dataFiles?.length > 0) || url !== ""
                  ? "flex"
                  : "none",
            }}
          >
            <FontAwesomeIcon
              icon={faFileAlt}
              color="rgba(0, 0, 0, 0.14)"
              style={{
                alignSelf: "center",
              }}
              size={"8x"}
            />
          </div>
          <Skeleton
            variant="rect"
            width={"100%"}
            style={{
              display: url === "" && !dataFiles ? "inherit" : "none",
              minHeight: "241px",
            }}
          />
        </CardActionArea>
        <CardActions>
          <label htmlFor={id}>
            <Button
              hidden={dataFiles && dataFiles?.length > 0}
              color="primary"
              component="span"
              disableElevation
              disabled={onLoad}
            >
              Upload
            </Button>
          </label>
          <Button
            color="default"
            component="span"
            disableElevation
            style={{
              display: url !== "" ? "inherit" : "none",
            }}
            onClick={() => {
              download();
            }}
          >
            Download
          </Button>
        </CardActions>
      </Card>

      <input
        accept={[extensions, DEFAULT_EXTENSIONS].join(",").replace(/^\,/, "")}
        id={id}
        type="file"
        name={name}
        style={{ display: "none" }}
        onChange={(e: any) => {
          onChangeFile(e.target.files);
        }}
      />
    </>
  );
};

export { InputFile };
